import React from "react";
import "./Buttons.scss";
import { useHistory } from "react-router-dom";

const Buttons = () => {
  const history = useHistory();

  const handleReattempt = () => {
    history.push("/test-instruction");
  };

  const handleSeeResponse = () => {
    history.push("/adv-analytics", { tab: "questionwise" });
  };

  return (
    <div className="basicAnalytics__buttons">
      <div
        className="basicAnalytics__buttons__button"
        onClick={handleReattempt}
      >
        Reattempt
      </div>

      <div
        className="basicAnalytics__buttons__button"
        onClick={handleSeeResponse}
      >
        See Response
      </div>
    </div>
  );
};

export default Buttons;
